var map = {
	"./add.svg": 1171,
	"./bar-charts.svg": 5358,
	"./battery-exchanger.svg": 1177,
	"./black-close.svg": 366,
	"./chart.svg": 9048,
	"./close.svg": 4573,
	"./danger.svg": 9648,
	"./devices.svg": 3500,
	"./down.svg": 4178,
	"./error.svg": 5810,
	"./fire-danger.svg": 7537,
	"./fire-station.svg": 7146,
	"./help.svg": 5271,
	"./human.svg": 721,
	"./index.svg": 5066,
	"./interface.svg": 3056,
	"./intime_dot.svg": 4623,
	"./offline.svg": 5880,
	"./operations.svg": 8855,
	"./raise.svg": 2628,
	"./records.svg": 4998,
	"./warning.svg": 5331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;